import { FunctionComponent } from 'react';

import { SearchInput } from '@kanda-libs/ks-component-ts';

import { URLS } from 'components/shared/App/constants';
import InfoBanner from 'components/shared/InfoBanner';
import PageTitle from 'components/shared/PageTitle';
import PresetFilter, {
  PresetFilterOption,
} from 'components/shared/PresetFilter';
import useQuery from 'hooks/useQuery';

export interface PaymentsInfoBannerProps {}

const PaymentsInfoBanner: FunctionComponent<PaymentsInfoBannerProps> =
  function () {
    const [query, setQuery] = useQuery('payments');
    const currentPath = window.location.href
      .split(window.location.host)[1]
      .split('?')[0];

    const options: PresetFilterOption[] = [
      { value: URLS.payments, text: 'Loan Payments' },
      { value: URLS.paymentsCard, text: 'Card Payments' },
      { value: URLS.paymentsCash, text: 'Cash Payments' },
      { value: URLS.paymentsAll, text: 'All Payments' },
    ];

    return (
      <>
        <PageTitle>Payments</PageTitle>
        <PresetFilter
          menuItem="payments"
          currentPath={currentPath}
          options={options}
        />
        <InfoBanner
          title="Payments"
          search={
            <SearchInput
              placeholder="Search loans"
              query={query}
              onSearch={setQuery}
            />
          }
        />
      </>
    );
  };

export default PaymentsInfoBanner;
